import React from 'react';
import {Button, SidePopup} from '@tickchak/react-share/app';
import Plus from '../../assets/icons/Plus';

interface AIMessageGeneratorHeaderProps {
    title: string;
    onClose: () => void;
    hasMessages: boolean;
    onNewChat: () => void;
    newChatLabel: string;
}

function AIMessageGeneratorHeader({
    title,
    onClose,
    hasMessages,
    onNewChat,
    newChatLabel,
}: AIMessageGeneratorHeaderProps) {
    return (
        <SidePopup.Header
            title={title}
            onClose={onClose}
            endSlot={hasMessages ? (
                <Button
                    variant="brand"
                    size="category"
                    iconStart={<Plus width={16} height={16} fill="currentColor" />}
                    onClick={onNewChat}
                    ariaLabel={newChatLabel}
                    data-cy="ai-message-generator-new-chat"
                />
            ) : undefined}
            className="ai-message-generator-header"
            data-cy="ai-message-generator-header"
        />
    );
}

export default AIMessageGeneratorHeader;
